import React, { useRef } from 'react'
import { IonIcon } from "@ionic/react";
import { cameraOutline, personCircleOutline } from "ionicons/icons";
import styles from './Profile.module.css';

interface ProfileAvatarProps {
  profileImgUrl: string | null;
  handleProfileImgChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isSelf?: boolean;
}

const ProfileAvatar = ({ profileImgUrl, handleProfileImgChange, isSelf }: ProfileAvatarProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const openFileDialog = () => {
    if (isSelf) {
      fileInputRef.current?.click();
    }
  };
  
  return (
    <div className={styles.container} onClick={openFileDialog}>
      <div className={styles.avatarWrapper}>
        {profileImgUrl ? (
          <img src={profileImgUrl} alt="Profile" className={styles.avatarImage} />
        ) : (
          <IonIcon icon={personCircleOutline} className={styles.avatarPlaceholder} />
        )}

        {isSelf
          ? (
            <div className={styles.cameraIcon}>
              <IonIcon icon={cameraOutline} />
            </div>
          )
          : null
        }
      </div>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className={styles.hiddenInput}
        onChange={handleProfileImgChange}
      />
    </div>
  );
}

export default ProfileAvatar